// extracted by LIB_CSS_EXTRACT_LOADER
import "./accordion_module.css"
export default {"item":"item-WB_X_n","header":"header-GhDVIA","trigger":"trigger-HOApWH","icon":"icon-lTsGA_","panel":"panel-jN8QuI","panelInner":"panelInner-QIHjN_"};